document.addEventListener("DOMContentLoaded", function () {
  const orderFormContainer =
    document.getElementById("NDISOrderForm") ||
    document.querySelector(".ndis-order-form") ||
    document;

  // 1. Group related field blocks dynamically (e.g. Shipping Address, Full Name)
  const containers = document.querySelectorAll(
    ".ndis-form__blocks, .ndis-form__collapsible-grid",
  );
  containers.forEach((container) => {
    const blocks = Array.from(container.children);
    let currentGroup = [];

    const flushGroup = () => {
      if (currentGroup.length > 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "ndis-form__field-group";

        // Insert wrapper before the first element
        container.insertBefore(wrapper, currentGroup[0]);
        // Append all elements in group to wrapper
        currentGroup.forEach((el) => wrapper.appendChild(el));
        currentGroup = [];
      }
    };

    blocks.forEach((block) => {
      // Check if it's a field block, product row, or accordion
      const isFieldBlock =
        block.querySelector(".ndis-form__field") ||
        block.classList.contains("ndis-product-row") ||
        block.classList.contains("ndis-form__accordion");
      if (!isFieldBlock) {
        flushGroup();
        return;
      }

      // If it's a product row or accordion group, keep them as single block elements
      if (
        block.classList.contains("ndis-product-row") ||
        block.classList.contains("ndis-form__accordion")
      ) {
        flushGroup();
        currentGroup.push(block);
        flushGroup();
        return;
      }

      const labelEl = block.querySelector(".ndis-form__label");
      const labelText = labelEl ? labelEl.textContent.trim() : "";
      // Clean label to check if it's empty or sub-label block
      const cleanLabel = labelText.replace(/[\s\u00a0*]/g, "");

      if (cleanLabel !== "") {
        flushGroup();
      }
      currentGroup.push(block);
    });
    flushGroup();
  });

  // 2. Setup date input picker and autofill with today's date
  const dateInput = document.querySelector('input[placeholder="MM-DD-YYYY"]');
  if (dateInput) {
    dateInput.type = "date";
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const todayStr = `${yyyy}-${mm}-${dd}`;
    dateInput.value = todayStr;
    dateInput.min = todayStr;
  }

  // Dynamic Input Validation based on schema settings
  const dynamicInputs = orderFormContainer.querySelectorAll(
    "[data-input-validation]",
  );
  dynamicInputs.forEach((input) => {
    const validationType = input.getAttribute("data-input-validation");

    input.addEventListener("input", function () {
      if (validationType === "numeric") {
        this.value = this.value.replace(/[^0-9]/g, "");
      } else if (validationType === "phone") {
        this.value = this.value.replace(/[^0-9+]/g, "");
      }
    });
  });

  // Force quantity inputs to only accept numbers
  const qtyInputs = orderFormContainer.querySelectorAll(".ndis-product-qty");
  qtyInputs.forEach((input) => {
    input.addEventListener("input", function () {
      this.value = this.value.replace(/[^0-9]/g, "");
    });
    input.addEventListener("keydown", function (e) {
      if (["e", "E", "+", "-", "."].includes(e.key)) {
        e.preventDefault();
      }
    });
  });

  // Toggle NDIS Plan Manager Email Access
  const invoiceCheckboxes = document.querySelectorAll(
    'input[name="contact[Send Tax Invoice To][]"], input[name="contact[Send Tax Invoice To]"]',
  );
  const planManagerEmailInput = document.querySelector(
    'input[name="contact[Plan Manager Email]"]',
  );

  if (invoiceCheckboxes.length > 0 && planManagerEmailInput) {
    const togglePlanManagerEmail = () => {
      let isPlanManagerSelected = false;
      invoiceCheckboxes.forEach((cb) => {
        if (cb.value === "NDIS Plan Manager" && cb.checked) {
          isPlanManagerSelected = true;
        }
      });

      if (isPlanManagerSelected) {
        planManagerEmailInput.removeAttribute("disabled");
        planManagerEmailInput.closest(".ndis-form__block-item").style.opacity =
          "1";
        planManagerEmailInput.closest(
          ".ndis-form__block-item",
        ).style.pointerEvents = "auto";
      } else {
        planManagerEmailInput.setAttribute("disabled", "disabled");
        planManagerEmailInput.value = ""; // clear value when disabled
        planManagerEmailInput.closest(".ndis-form__block-item").style.opacity =
          "0.5";
        planManagerEmailInput.closest(
          ".ndis-form__block-item",
        ).style.pointerEvents = "none";

        // Remove error states if disabled
        const fieldGroup =
          planManagerEmailInput.closest(".ndis-form__field-group") ||
          planManagerEmailInput.closest(".ndis-form__field");
        if (fieldGroup) {
          fieldGroup.classList.remove("has-error");
          const errMsg = fieldGroup.querySelector(".ndis-form__error-message");
          if (errMsg) errMsg.remove();
        }
      }
    };

    invoiceCheckboxes.forEach((cb) => {
      cb.addEventListener("change", togglePlanManagerEmail);
    });

    // Initial check
    togglePlanManagerEmail();
  }

  // 3. Size/product dropdown selection → fetch colour options via /products/{handle}.json
  document.addEventListener("change", async function (e) {
    if (e.target && e.target.classList.contains("ndis-product-size")) {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const handle = selectedOption.value;
      const id = selectedOption.getAttribute("data-product-id");
      const row = e.target.closest(".ndis-product-row");

      if (row) {
        // ONLY fetch colors dynamically if we are in a product LIST mode.
        // Single product modes already output colors correctly via Liquid.
        if (!row.hasAttribute("data-product-list-mode")) return;

        // Only treat value as a product handle when it has a matching data-product-id
        // (list mode). Plain text size values like "Single" are not handles.
        if (id && handle) {
          row.setAttribute("data-product-handle", handle);
        } else {
          row.removeAttribute("data-product-handle");
        }
        if (id) {
          row.setAttribute("data-product-id", id);
        } else {
          row.removeAttribute("data-product-id");
        }

        const colorSelect = row.querySelector(".ndis-product-color");
        const colorField = row.querySelector(".ndis-product-color-field");

        if (colorSelect) {
          if (!handle) {
            // No product selected — reset colour
            colorSelect.innerHTML = `<option value="" selected>Please Select</option>`;
            updateDuplicateSelections();
            return;
          }

          // Use the data-colors attribute rendered by Liquid
          const colorsStr = selectedOption.getAttribute("data-colors");
          colorSelect.innerHTML = `<option value="" selected>Please Select</option>`;

          if (colorsStr && colorsStr.trim() !== "") {
            const colorsArray = colorsStr.split(",");

            let variantsData = null;
            if (selectedOption) {
              const vData = selectedOption.getAttribute("data-variants");
              if (vData) {
                try {
                  variantsData = JSON.parse(vData);
                } catch (e) {}
              }
            }

            colorsArray.forEach((val) => {
              const cleanVal = val.trim();
              if (cleanVal) {
                const opt = document.createElement("option");
                opt.value = cleanVal;
                opt.textContent = cleanVal;

                if (variantsData) {
                  const normColor = cleanVal
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, "");
                  const isAvailable = variantsData.some((v) => {
                    const o1 = (v.option1 || "")
                      .toLowerCase()
                      .replace(/[^a-z0-9]/g, "");
                    const o2 = (v.option2 || "")
                      .toLowerCase()
                      .replace(/[^a-z0-9]/g, "");
                    const o3 = (v.option3 || "")
                      .toLowerCase()
                      .replace(/[^a-z0-9]/g, "");
                    if (
                      o1 === normColor ||
                      o2 === normColor ||
                      o3 === normColor
                    ) {
                      return v.available;
                    }
                    return false;
                  });
                  const checkInventory =
                    document
                      .getElementById("NDISOrderForm")
                      .getAttribute("data-inventory-validation") !== "false";
                  if (checkInventory && !isAvailable) {
                    return; // Skip adding this option completely
                  }
                }

                colorSelect.appendChild(opt);
              }
            });
          }
          updateDuplicateSelections();
        }
      }
    }
  });

  function getVariantForHypotheticalSelection(
    row,
    sizeVal,
    colorVal,
    sizeOpt = null,
  ) {
    const isList = row.hasAttribute("data-product-list-mode");
    let variantsData = null;

    if (isList) {
      const sizeSelect = row.querySelector(".ndis-product-size");
      const opt =
        sizeOpt ||
        (sizeSelect ? sizeSelect.options[sizeSelect.selectedIndex] : null);
      if (opt && opt.value) {
        const vData = opt.getAttribute("data-variants");
        if (vData) {
          try {
            variantsData = JSON.parse(vData);
          } catch (e) {}
        }
      }
    } else {
      const vData = row.getAttribute("data-variants");
      if (vData) {
        try {
          variantsData = JSON.parse(vData);
        } catch (e) {}
      }
    }

    if (!variantsData) return null;

    const normColor = colorVal
      ? colorVal.toLowerCase().replace(/[^a-z0-9]/g, "")
      : "";
    const normSize =
      !isList && sizeVal ? sizeVal.toLowerCase().replace(/[^a-z0-9]/g, "") : "";

    const matched = variantsData.find((v) => {
      const optValues = [v.option1, v.option2, v.option3]
        .filter(Boolean)
        .map((o) => o.toLowerCase().replace(/[^a-z0-9]/g, ""));
      let matchesColor = true;
      let matchesSize = true;

      if (normColor) {
        matchesColor = optValues.some((val) => val === normColor);
      }
      if (normSize) {
        matchesSize = optValues.some((val) => val === normSize);
      }
      return matchesColor && matchesSize;
    });

    return matched || null;
  }

  function getSelectedVariantId(row) {
    const isList = row.hasAttribute("data-product-list-mode");
    const sizeSelect = row.querySelector(".ndis-product-size");
    const colorSelect = row.querySelector(".ndis-product-color");

    const sizeVal = sizeSelect ? sizeSelect.value : "";
    const colorVal = colorSelect ? colorSelect.value : "";

    if (isList && !sizeVal) return null;
    if (!isList && sizeSelect && sizeSelect.options.length > 1 && !sizeVal)
      return null;

    let requiresColor = false;
    if (isList) {
      if (sizeSelect && sizeSelect.selectedIndex > 0) {
        const opt = sizeSelect.options[sizeSelect.selectedIndex];
        const colors = opt.getAttribute("data-colors");
        if (colors && colors.trim() !== "") {
          requiresColor = true;
        }
      }
    } else {
      if (colorSelect && colorSelect.options.length > 1) {
        requiresColor = true;
      }
    }

    if (requiresColor && !colorVal) return null;

    const variant = getExactVariant(row);
    return variant ? variant.id : null;
  }

  function updateDuplicateSelections() {
    const allRows = Array.from(
      orderFormContainer.querySelectorAll(".ndis-product-row"),
    );
    const selectedVariantsMap = new Map();

    allRows.forEach((row) => {
      const vId = getSelectedVariantId(row);
      if (vId) {
        selectedVariantsMap.set(row, vId);
      }
    });

    const isVariantSelectedElsewhere = (vId, currentRow) => {
      for (const [row, otherVId] of selectedVariantsMap.entries()) {
        if (row !== currentRow && otherVId === vId) {
          return true;
        }
      }
      return false;
    };

    allRows.forEach((row) => {
      const sizeSelect = row.querySelector(".ndis-product-size");
      const colorSelect = row.querySelector(".ndis-product-color");
      const isList = row.hasAttribute("data-product-list-mode");

      const sizeVal = sizeSelect ? sizeSelect.value : "";
      const colorVal = colorSelect ? colorSelect.value : "";

      if (sizeSelect) {
        Array.from(sizeSelect.options).forEach((opt) => {
          if (!opt.value) return;

          let hypotheticalVariant = null;
          if (isList) {
            const colorsStr = opt.getAttribute("data-colors");
            if (!colorsStr || colorsStr.trim() === "") {
              hypotheticalVariant = getVariantForHypotheticalSelection(
                row,
                opt.value,
                "",
                opt,
              );
            }
          } else {
            hypotheticalVariant = getVariantForHypotheticalSelection(
              row,
              opt.value,
              colorVal,
            );
          }

          if (
            hypotheticalVariant &&
            isVariantSelectedElsewhere(hypotheticalVariant.id, row)
          ) {
            opt.disabled = true;
            if (!opt.textContent.includes("Already selected")) {
              opt.textContent = opt.textContent.trim() + " (Already selected)";
            }
          } else {
            opt.disabled = false;
            opt.textContent = opt.textContent.replace(
              /\s*\(Already selected\)/g,
              "",
            );
          }
        });
      }

      if (colorSelect) {
        Array.from(colorSelect.options).forEach((opt) => {
          if (!opt.value) return;

          const hypotheticalVariant = getVariantForHypotheticalSelection(
            row,
            sizeVal,
            opt.value,
          );
          if (
            hypotheticalVariant &&
            isVariantSelectedElsewhere(hypotheticalVariant.id, row)
          ) {
            opt.disabled = true;
            if (!opt.textContent.includes("Already selected")) {
              opt.textContent = opt.textContent.trim() + " (Already selected)";
            }
          } else {
            opt.disabled = false;
            opt.textContent = opt.textContent.replace(
              /\s*\(Already selected\)/g,
              "",
            );
          }
        });
      }
    });

    // Re-validate all product rows to clear/add error states dynamically
    allRows.forEach((row) => {
      validateProductRow(row);
    });
  }

  function getExactVariant(row) {
    const isList = row.hasAttribute("data-product-list-mode");
    const sizeSelect = row.querySelector(".ndis-product-size");
    const colorSelect = row.querySelector(".ndis-product-color");

    const colorVal = colorSelect ? colorSelect.value.trim() : "";
    const normColor = colorVal.toLowerCase().replace(/[^a-z0-9]/g, "");

    let variantsData = null;
    let sizeVal = "";

    if (isList) {
      if (sizeSelect && sizeSelect.selectedIndex > 0) {
        const opt = sizeSelect.options[sizeSelect.selectedIndex];
        const vData = opt.getAttribute("data-variants");
        if (vData) {
          try {
            variantsData = JSON.parse(vData);
          } catch (e) {}
        }
      }
    } else {
      const vData = row.getAttribute("data-variants");
      if (vData) {
        try {
          variantsData = JSON.parse(vData);
        } catch (e) {}
      }
      sizeVal = sizeSelect ? sizeSelect.value.trim() : "";
    }

    if (!variantsData) return null;

    const normSize = sizeVal.toLowerCase().replace(/[^a-z0-9]/g, "");

    const matched = variantsData.find((v) => {
      const optValues = [v.option1, v.option2, v.option3]
        .filter(Boolean)
        .map((o) => o.toLowerCase().replace(/[^a-z0-9]/g, ""));
      let matchesColor = true;
      let matchesSize = true;

      if (normColor) {
        matchesColor = optValues.some((val) => val === normColor);
      }
      if (normSize) {
        matchesSize = optValues.some((val) => val === normSize);
      }
      return matchesColor && matchesSize;
    });

    return matched || null;
  }

  function validateProductRow(row) {
    let hasError = false;

    // Clear previous inventory errors in this row first
    const existingErrs = row.querySelectorAll(
      ".ndis-form__error-message.inventory-error",
    );
    existingErrs.forEach((err) => err.remove());

    // Only remove has-error if there's no other required-field error in the row
    if (!row.querySelector(".ndis-form__error-message")) {
      row.classList.remove("has-error");
    }

    const qtyInput = row.querySelector(".ndis-product-qty");
    const qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;

    const sizeSelect = row.querySelector(".ndis-product-size");
    const colorSelect = row.querySelector(".ndis-product-color");

    const sizeVal = sizeSelect ? sizeSelect.value : "";
    const colorVal = colorSelect ? colorSelect.value : "";

    // Determine if color is actually required for this product
    let requiresColor = false;
    if (row.hasAttribute("data-product-list-mode")) {
      if (sizeSelect && sizeSelect.selectedIndex > 0) {
        const opt = sizeSelect.options[sizeSelect.selectedIndex];
        const colors = opt.getAttribute("data-colors");
        if (colors && colors.trim() !== "") {
          requiresColor = true;
        }
      }
    } else {
      if (colorSelect && colorSelect.options.length > 1) {
        requiresColor = true;
      }
    }

    const hasAnyInput = qty > 0 || sizeVal !== "" || colorVal !== "";

    if (hasAnyInput) {
      let rowError = null;

      if (sizeSelect && sizeSelect.options.length > 1 && sizeVal === "") {
        rowError = "Please select a size/product.";
      } else if (requiresColor && colorVal === "") {
        rowError = "Please select a colour.";
      } else if (qty <= 0) {
        rowError = "Quantity is required.";
      } else {
        // First check for duplicate selections
        const currentVariantId = getSelectedVariantId(row);
        if (currentVariantId) {
          const isDuplicate = Array.from(
            orderFormContainer.querySelectorAll(".ndis-product-row"),
          ).some((otherRow) => {
            if (otherRow === row) return false;
            return getSelectedVariantId(otherRow) === currentVariantId;
          });
          if (isDuplicate) {
            rowError =
              "This product/variant is already selected in another row.";
          }
        }

        if (!rowError) {
          const checkInventory =
            document
              .getElementById("NDISOrderForm")
              .getAttribute("data-inventory-validation") !== "false";
          if (checkInventory) {
            const variant = getExactVariant(row);
            if (!variant) {
              rowError = "Selected product/variant is not available.";
            } else {
              if (!variant.available) {
                rowError = "Selected product/variant is out of stock.";
              } else if (
                variant.management === "shopify" &&
                variant.policy === "deny" &&
                qty > variant.qty
              ) {
                rowError = `Only ${variant.qty} available in stock.`;
              }
            }
          }
        }
      }

      if (rowError) {
        hasError = true;
        row.classList.add("has-error");
        let errMsg = row.querySelector(
          ".ndis-form__error-message.inventory-error",
        );
        if (!errMsg) {
          errMsg = document.createElement("div");
          errMsg.className = "ndis-form__error-message inventory-error";
          row.appendChild(errMsg);
        }
        errMsg.innerHTML = `
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width:16px; margin-right:6px; vertical-align:middle;">
            <circle cx="8" cy="8" r="8" fill="white"/>
            <path d="M8 3.5V8.5" stroke="#ff2e0e" stroke-width="2" stroke-linecap="round"/>
            <circle cx="8" cy="11.5" r="1" fill="#ff2e0e"/>
          </svg>
          ${rowError}
        `;
      }
    }
    return hasError;
  }

  if (orderFormContainer) {
    orderFormContainer.setAttribute("novalidate", "novalidate");

    // Dynamic error clearing listeners on change/input
    const setupErrorClearing = () => {
      const requiredInputs = orderFormContainer.querySelectorAll(
        "input[required], select[required], textarea[required], .ndis-product-qty, .ndis-product-size, .ndis-product-color",
      );
      requiredInputs.forEach((input) => {
        const clearError = () => {
          const fieldGroup =
            input.closest(".ndis-form__field-group") ||
            input.closest(".ndis-product-row");
          if (fieldGroup && fieldGroup.classList.contains("has-error")) {
            const groupFields = fieldGroup.querySelectorAll(
              "input[required], select[required], textarea[required], .ndis-form__checkbox-group[data-required='true']",
            );
            let groupHasErrors = false;

            groupFields.forEach((field) => {
              let fieldValid = true;
              if (field.classList.contains("ndis-form__checkbox-group")) {
                fieldValid =
                  field.querySelectorAll("input[type='checkbox']:checked")
                    .length > 0;
              } else if (field.type === "checkbox") {
                fieldValid = field.checked;
              } else if (field.type === "email") {
                const val = field.value.trim();
                if (val === "") {
                  fieldValid = false;
                } else {
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  fieldValid = emailRegex.test(val);
                }
              } else if (
                field.type === "date" ||
                field.getAttribute("placeholder") === "MM-DD-YYYY"
              ) {
                const val = field.value.trim();
                if (val === "") {
                  fieldValid = false;
                } else {
                  const selectedDate = new Date(val);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  selectedDate.setHours(0, 0, 0, 0);
                  fieldValid = selectedDate >= today;
                }
              } else {
                fieldValid = field.value.trim() !== "";
              }

              if (!fieldValid) {
                groupHasErrors = true;
              }
            });

            // Re-validate inventory for the row dynamically
            const row = fieldGroup.closest(".ndis-product-row");
            if (row) {
              const hasInventoryError = validateProductRow(row);
              if (hasInventoryError) {
                groupHasErrors = true;
              }
            }

            if (!groupHasErrors) {
              fieldGroup.classList.remove("has-error");
              const errLabels = fieldGroup.querySelectorAll(
                ".ndis-form__error-message",
              );
              errLabels.forEach((el) => {
                // Don't remove inventory errors here, validateProductRow handles them.
                if (!el.classList.contains("inventory-error")) {
                  el.remove();
                }
              });
            }

            // Update general sticky banner count
            const activeErrors = orderFormContainer.querySelectorAll(
              ".ndis-form__field-group.has-error, .ndis-product-row.has-error",
            );
            const banner = document.getElementById("NDISFormErrorBanner");
            if (banner) {
              if (activeErrors.length === 0) {
                banner.classList.remove("is-visible");
                setTimeout(() => banner.remove(), 300);
              } else {
                const activeCount = activeErrors.length;
                const errorWord = activeCount === 1 ? "error" : "errors";
                const pronoun = activeCount === 1 ? "it" : "them";
                const textSpan = banner.querySelector(
                  ".ndis-form__error-banner-text",
                );
                if (textSpan) {
                  textSpan.innerHTML = `There is <span class="ndis-form__error-count-badge">${activeCount}</span> ${errorWord} on this page. Please correct ${pronoun} before moving on.`;
                }
              }
            }
          }
        };
        input.addEventListener("input", clearError);
        input.addEventListener("change", clearError);
      });

      // Also checkbox groups
      const requiredCheckboxes = orderFormContainer.querySelectorAll(
        ".ndis-form__checkbox-group[data-required='true']",
      );
      requiredCheckboxes.forEach((group) => {
        const checkboxes = group.querySelectorAll("input[type='checkbox']");
        checkboxes.forEach((cb) => {
          cb.addEventListener("change", () => {
            const fieldGroup = group.closest(".ndis-form__field-group");
            if (fieldGroup && fieldGroup.classList.contains("has-error")) {
              const checkedCount = group.querySelectorAll(
                "input[type='checkbox']:checked",
              ).length;
              if (checkedCount > 0) {
                const groupFields = fieldGroup.querySelectorAll(
                  "input[required], select[required], textarea[required], .ndis-form__checkbox-group[data-required='true']",
                );
                let groupHasErrors = false;
                groupFields.forEach((field) => {
                  if (field !== group) {
                    let fieldValid = true;
                    if (field.classList.contains("ndis-form__checkbox-group")) {
                      fieldValid =
                        field.querySelectorAll("input[type='checkbox']:checked")
                          .length > 0;
                    } else if (field.type === "checkbox") {
                      fieldValid = field.checked;
                    } else if (field.type === "email") {
                      const val = field.value.trim();
                      if (val === "") {
                        fieldValid = false;
                      } else {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        fieldValid = emailRegex.test(val);
                      }
                    } else {
                      fieldValid = field.value.trim() !== "";
                    }
                    if (!fieldValid) groupHasErrors = true;
                  }
                });

                if (!groupHasErrors) {
                  fieldGroup.classList.remove("has-error");
                  const errLabels = fieldGroup.querySelectorAll(
                    ".ndis-form__error-message",
                  );
                  errLabels.forEach((el) => el.remove());
                }
              }

              // Update general sticky banner count
              const activeErrors = orderFormContainer.querySelectorAll(
                ".ndis-form__field-group.has-error, .ndis-product-row.has-error",
              );
              const banner = document.getElementById("NDISFormErrorBanner");
              if (banner) {
                if (activeErrors.length === 0) {
                  banner.classList.remove("is-visible");
                  setTimeout(() => banner.remove(), 300);
                } else {
                  const activeCount = activeErrors.length;
                  const errorWord = activeCount === 1 ? "error" : "errors";
                  const pronoun = activeCount === 1 ? "it" : "them";
                  const textSpan = banner.querySelector(
                    ".ndis-form__error-banner-text",
                  );
                  if (textSpan) {
                    textSpan.innerHTML = `There is <span class="ndis-form__error-count-badge">${activeCount}</span> ${errorWord} on this page. Please correct ${pronoun} before moving on.`;
                  }
                }
              }
            }
          });
        });
      });

      // Bind explicit blur/change validations for inventory
      const productInputs = orderFormContainer.querySelectorAll(
        ".ndis-product-qty, .ndis-product-size, .ndis-product-color",
      );
      productInputs.forEach((input) => {
        const handleInteraction = () => {
          const row = input.closest(".ndis-product-row");
          if (row) {
            validateProductRow(row);
          }
        };
        input.addEventListener("blur", handleInteraction);
        input.addEventListener("change", function () {
          handleInteraction();
          updateDuplicateSelections();
        });
      });
    };

    // Initialize error clearing listeners
    setupErrorClearing();
    updateDuplicateSelections();

    orderFormContainer.addEventListener(
      "submit",
      async function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        console.log("[NDIS] Submit fired");

        // Clear previous error states
        const previousErrors = orderFormContainer.querySelectorAll(
          ".ndis-form__field-group.has-error, .ndis-product-row.has-error",
        );
        previousErrors.forEach((group) => {
          group.classList.remove("has-error");
          const errLabels = group.querySelectorAll(".ndis-form__error-message");
          errLabels.forEach((el) => el.remove());
        });

        const existingBanner = document.getElementById("NDISFormErrorBanner");
        if (existingBanner) existingBanner.remove();

        let errorCount = 0;
        let firstInvalidInput = null;

        // Validate required fields/groups
        const requiredFields = orderFormContainer.querySelectorAll(
          "input[required], select[required], textarea[required], .ndis-form__checkbox-group[data-required='true']",
        );
        requiredFields.forEach((field) => {
          let isValid = true;
          let dateErrorMsg = "";

          if (field.classList.contains("ndis-form__checkbox-group")) {
            const checkedCount = field.querySelectorAll(
              "input[type='checkbox']:checked",
            ).length;
            isValid = checkedCount > 0;
          } else if (field.type === "checkbox") {
            isValid = field.checked;
          } else if (field.type === "email") {
            const val = field.value.trim();
            if (val === "") {
              isValid = false;
            } else {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              isValid = emailRegex.test(val);
            }
          } else if (
            field.type === "date" ||
            field.getAttribute("placeholder") === "MM-DD-YYYY"
          ) {
            const val = field.value.trim();
            if (val === "") {
              isValid = false;
            } else {
              const selectedDate = new Date(val);
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              selectedDate.setHours(0, 0, 0, 0);
              if (selectedDate < today) {
                isValid = false;
                dateErrorMsg = "Date cannot be in the past.";
              }
            }
          } else {
            isValid = field.value.trim() !== "";
          }

          if (!isValid) {
            errorCount++;
            const fieldGroup =
              field.closest(".ndis-form__field-group") ||
              field.closest(".ndis-form__field");
            if (fieldGroup) {
              fieldGroup.classList.add("has-error");
              if (!fieldGroup.querySelector(".ndis-form__error-message")) {
                const errMsg = document.createElement("div");
                errMsg.className = "ndis-form__error-message";
                errMsg.innerHTML = `
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width:16px; margin-right:6px; vertical-align:middle;">
                  <circle cx="8" cy="8" r="8" fill="white"/>
                  <path d="M8 3.5V8.5" stroke="#ff2e0e" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="8" cy="11.5" r="1" fill="#ff2e0e"/>
                </svg>
                ${dateErrorMsg || "This field is required."}
              `;
                fieldGroup.appendChild(errMsg);
              }
            }

            if (!firstInvalidInput) {
              firstInvalidInput = field;
            }
          }
        });

        // Product and Inventory Validation
        const productRows =
          orderFormContainer.querySelectorAll(".ndis-product-row");
        productRows.forEach((row) => {
          const hasInventoryError = validateProductRow(row);
          if (hasInventoryError) {
            errorCount++;
            if (!firstInvalidInput) {
              firstInvalidInput = row.querySelector(".ndis-product-qty");
            }
          }
        });

        console.log("[NDIS] Validation done. Errors:", errorCount);
        if (errorCount > 0 && firstInvalidInput) {
          console.log(
            "[NDIS] First failing field:",
            firstInvalidInput.name,
            "| type:",
            firstInvalidInput.type,
            "| value:",
            firstInvalidInput.value,
            "| element:",
            firstInvalidInput,
          );
        }

        if (errorCount > 0) {
          // Create the sticky error banner at the bottom of the viewport
          let banner = document.getElementById("NDISFormErrorBanner");
          const errorWord = errorCount === 1 ? "error" : "errors";
          const pronoun = errorCount === 1 ? "it" : "them";

          if (!banner) {
            banner = document.createElement("div");
            banner.id = "NDISFormErrorBanner";
            banner.className = "ndis-form__error-banner-sticky";
            const actionsDiv = orderFormContainer.querySelector(
              ".ndis-form__actions",
            );
            if (actionsDiv) {
              actionsDiv.appendChild(banner);
            } else {
              orderFormContainer.appendChild(banner);
            }
          }

          banner.innerHTML = `
          <div class="ndis-form__error-banner-content">
            <span class="ndis-form__error-banner-text">
              Please fix <span class="ndis-form__error-count-badge">${errorCount}</span> ${errorWord} ${pronoun} to continue..
            </span>
            <button type="button" class="ndis-form__see-errors-btn">See Errors</button>
          </div>
        `;

          banner
            .querySelector(".ndis-form__see-errors-btn")
            .addEventListener("click", function () {
              if (firstInvalidInput) {
                const details = firstInvalidInput.closest("details");
                if (details) {
                  details.open = true;
                }

                const fieldGroup =
                  firstInvalidInput.closest(".ndis-form__field-group") ||
                  firstInvalidInput.closest(".ndis-product-row");
                if (fieldGroup) {
                  fieldGroup.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                } else {
                  firstInvalidInput.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                  });
                }

                setTimeout(() => {
                  if (
                    firstInvalidInput.classList.contains(
                      "ndis-form__checkbox-group",
                    )
                  ) {
                    const firstCb = firstInvalidInput.querySelector(
                      "input[type='checkbox']",
                    );
                    if (firstCb) firstCb.focus();
                  } else if (typeof firstInvalidInput.focus === "function") {
                    firstInvalidInput.focus();
                  }
                }, 400);
              }
            });

          // Trigger transition
          setTimeout(() => {
            banner.classList.add("is-visible");
          }, 10);

          return;
        }

        const lineItems = [];

        productRows.forEach((row) => {
          const qtyInput = row.querySelector(".ndis-product-qty");
          const qty = qtyInput ? parseInt(qtyInput.value) || 0 : 0;

          if (qty > 0) {
            const colorSelect = row.querySelector(".ndis-product-color");
            const sizeSelect = row.querySelector(".ndis-product-size");

            const color = colorSelect ? colorSelect.value : "";
            const size = sizeSelect ? sizeSelect.value : "";

            if (color || size || getExactVariant(row)) {
              const matched = getExactVariant(row);
              console.log(
                "[NDIS] Variant match:",
                matched ? matched.id + " (" + matched.title + ")" : "NONE",
              );

              if (matched) {
                const customAttributes = [];
                if (color)
                  customAttributes.push({ key: "Colour", value: color });
                if (size) customAttributes.push({ key: "Size", value: size });

                const lineItem = {
                  variantId: `gid://shopify/ProductVariant/${matched.id}`,
                  quantity: qty,
                };
                if (customAttributes.length > 0) {
                  lineItem.customAttributes = customAttributes;
                }
                lineItems.push(lineItem);
              }
            }
          }
        });

        if (lineItems.length === 0) {
          let banner = document.getElementById("NDISFormErrorBanner");
          if (!banner) {
            banner = document.createElement("div");
            banner.id = "NDISFormErrorBanner";
            banner.className = "ndis-form__error-banner-sticky";
            const actionsDiv = orderFormContainer.querySelector(
              ".ndis-form__actions",
            );
            if (actionsDiv) {
              actionsDiv.appendChild(banner);
            } else {
              orderFormContainer.appendChild(banner);
            }
          }

          banner.innerHTML = `
          <div class="ndis-form__error-banner-content">
            <span class="ndis-form__error-banner-text">
              <span class="ndis-form__error-count-badge">!</span> Please select at least one product to submit your order.
            </span>
          </div>
          `;

          setTimeout(() => {
            banner.classList.add("is-visible");
          }, 10);

          return;
        }

        // Collect custom attributes and form fields
        let personalEmail = "";
        let participantFirstName = "";
        let participantLastName = "";
        let ndisParticipantNumber = "";
        let phoneVal = "";

        let street1 = "";
        let street2 = "";
        let cityVal = "";
        let stateVal = "";
        let postcodeVal = "";
        let countryVal = "Australia";

        const customAttributes = [];
        let noteText = "";

        const allInputs = orderFormContainer.querySelectorAll(
          "input, select, textarea",
        );
        allInputs.forEach((input) => {
          if (input.classList.contains("ndis-product-input")) return;
          if (input.type === "submit" || input.type === "hidden") return;

          // Strip standard prefix or check ID to map customer details
          const name = input.name
            .replace(/^contact\[/, "")
            .replace(/\]\[\]$/, "")
            .replace(/\]$/, "");
          const val = input.value;

          if (input.type === "checkbox") {
            if (input.checked) {
              const existingAttr = customAttributes.find(
                (attr) => attr.key === name,
              );
              if (existingAttr) {
                existingAttr.value += " & " + val;
              } else {
                customAttributes.push({ key: name, value: val });
              }
            }
            return;
          }

          if (!val) return;

          // Normalize keys for mapping
          const normKey = name.toLowerCase().replace(/[^a-z0-9]/g, "");

          if (normKey.includes("firstname")) {
            participantFirstName = val;
          } else if (normKey.includes("lastname")) {
            participantLastName = val;
          } else if (
            normKey.includes("personalemail") ||
            normKey.includes("emailaddress")
          ) {
            personalEmail = val;
          } else if (normKey.includes("phone")) {
            phoneVal = val;
          } else if (
            normKey.includes("streetaddressline2") ||
            normKey.includes("streetline2")
          ) {
            street2 = val;
          } else if (
            normKey.includes("streetaddress") ||
            normKey.includes("street1")
          ) {
            street1 = val;
          } else if (normKey.includes("city") || normKey.includes("suburb")) {
            cityVal = val;
          } else if (
            normKey.includes("state") ||
            normKey.includes("province")
          ) {
            stateVal = val;
          } else if (normKey.includes("postcode") || normKey.includes("zip")) {
            postcodeVal = val;
          } else if (normKey.includes("country")) {
            countryVal = val;
          } else {
            customAttributes.push({ key: name, value: val });
            if (normKey.includes("participantnumber")) {
              ndisParticipantNumber = val;
            }
          }
        });

        const participantFullName = `${participantFirstName} ${participantLastName}`
          .trim()
          .replace(/\s+/g, " ");

        const noteLines = [];
        if (ndisParticipantNumber) {
          noteLines.push(`NDIS Number ${ndisParticipantNumber}`);
        }
        if (participantFullName) noteLines.push(participantFullName);
        noteText = noteLines.join("\n");

        const formattedData = {
          customer: {
            email: personalEmail,
            firstName: participantFirstName,
            lastName: participantLastName,
            phone: phoneVal,
            shippingAddress: {
              address1: street1,
              address2: street2,
              city: cityVal,
              province: stateVal,
              zip: postcodeVal,
              country: countryVal,
              firstName: participantFirstName,
              lastName: participantLastName,
            },
          },
          lineItems: lineItems,
          note: noteText || "NDIS Order submission",
          customAttributes: customAttributes,
        };

        const submitBtn = orderFormContainer.querySelector(
          'button[type="submit"]',
        );
        const originalBtnText = submitBtn ? submitBtn.innerText : "Submit";
        if (submitBtn) {
          submitBtn.innerText = "Submitting...";
          submitBtn.disabled = true;
        }

        try {
          // Get shop domain dynamically
          const shopDomain = window.location.hostname;

          const apiUrl = `https://${shopDomain}/apps/data/create-draft-order`;

          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-form-token": "shpua_74db081afecc5b10b50832a4d23ae66e",
              "x-shop-domain": shopDomain,
            },
            body: JSON.stringify(formattedData),
          });

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `Failed to submit form to API. Status: ${response.status}. Response: ${errorText}`,
            );
          }

          // Hide error banner if successful
          const activeBanner = document.getElementById("NDISFormErrorBanner");
          if (activeBanner) {
            activeBanner.classList.remove("is-visible");
            setTimeout(() => activeBanner.remove(), 300);
          }

          // Success banner
          let successBanner = orderFormContainer.querySelector(
            ".ndis-form__success",
          );
          if (!successBanner) {
            successBanner = document.createElement("div");
            successBanner.className = "ndis-form__success";

            const successMsg =
              orderFormContainer.getAttribute("data-success-message") ||
              "Thank you! Your NDIS Order request has been received. Our team will email you shortly.";

            successBanner.innerHTML = `
            <svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width:16px;">
              <path d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM7 11.41L3.71 8.12L5.12 6.71L7 8.59L10.88 4.71L12.29 6.12L7 11.41Z" fill="green"/>
            </svg>
            <span>${successMsg}</span>
          `;
            orderFormContainer.prepend(successBanner);
          }
          successBanner.scrollIntoView({ behavior: "smooth", block: "center" });
        } catch (error) {
          console.error("[NDIS] API Error:", error);
          let banner = document.getElementById("NDISFormErrorBanner");
          if (!banner) {
            banner = document.createElement("div");
            banner.id = "NDISFormErrorBanner";
            banner.className = "ndis-form__error-banner-sticky";
            const actionsDiv = orderFormContainer.querySelector(
              ".ndis-form__actions",
            );
            if (actionsDiv) {
              actionsDiv.appendChild(banner);
            } else {
              orderFormContainer.appendChild(banner);
            }
          }
          banner.innerHTML = `
          <div class="ndis-form__error-banner-content">
            <span class="ndis-form__error-banner-text">
              <span class="ndis-form__error-count-badge">!</span> There was an error submitting your request. Please try again.
            </span>
          </div>
          `;
          setTimeout(() => {
            banner.classList.add("is-visible");
          }, 10);
        } finally {
          if (submitBtn) {
            submitBtn.innerText = originalBtnText;
            submitBtn.disabled = false;
          }
        }
      },
      { capture: true },
    );
  }
});
